var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("News for Cluster "+_vm._s(_vm.clusterId))])}
var staticRenderFns = []

export { render, staticRenderFns }